import { Component, Input, OnInit } from '@angular/core';
import { CheckoutContentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Component({
  selector: 'image-block',
  templateUrl: './image-block.component.html',
  styleUrls: ['./image-block.component.scss'],
  standalone: false,
})
export class ImageBlockComponent implements OnInit {
  @Input() block: CheckoutContentExtension.DynamicBlock;
  @Input() template: CheckoutContentExtension.Template;
  constructor() {}

  ngOnInit(): void {}
}
